import { render, staticRenderFns } from "./BaseModalBottom.vue?vue&type=template&id=46c7e4a9&scoped=true&"
import script from "./BaseModalBottom.vue?vue&type=script&lang=js&"
export * from "./BaseModalBottom.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalBottom.vue?vue&type=style&index=0&id=46c7e4a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c7e4a9",
  null
  
)

export default component.exports